.title {
  margin: 0;
  color: var(--ink);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 26px;
  /* One line: a long name is cut, never wrapped to a second line that makes the header taller. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
  border-radius: 4px;
}

.block {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

/* Small, muted, not uppercased: a company's name is a name. */
.eyebrow {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
  line-height: 16px;
  /* One line, like the title: an eyebrow that wraps pushes the title down inside a header of fixed height. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
